import React, { useState, useRef, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const items = [{
  emoji: '🎯',
  title: 'Playbook di Sequenze in PDF',
  desc: '12 protocolli tattici (corpo libero e piccoli attrezzi) spiegati con diagrammi HD. Per smettere di "disegnare nell\'aria".',
  color: 'bg-blue-500',
  shadow: 'shadow-[0_0_15px_rgba(59,130,246,0.5)]'
}, {
  emoji: '📋',
  title: '15 Schede Tecniche Digitali',
  desc: 'Documenti PDF progettati per essere mostrati sul tuo tablet/smartphone o stampati. Correzioni posturali chiare perché i tuoi allievi capiscano al primo colpo.',
  color: 'bg-green-500',
  shadow: 'shadow-[0_0_15px_rgba(34,197,94,0.5)]'
}, {
  emoji: '📱',
  title: 'Guida al Business per Istruttori (PDF)',
  desc: 'La metodologia per gestire i tuoi clienti, i prezzi e il marketing del tuo studio senza stress.',
  color: 'bg-purple-500',
  shadow: 'shadow-[0_0_15px_rgba(168,85,247,0.5)]'
}, {
  emoji: '🧘',
  title: 'Manuale di Adattamenti Specifici PDF',
  desc: "L'allenamento che spesso dimentichiamo. Posizionamento e tecniche per patologie comuni e popolazioni speciali (Senior, Gravidanza).",
  color: 'bg-orange-500',
  shadow: 'shadow-[0_0_15px_rgba(249,115,22,0.5)]'
}];
const carouselImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/9He7Kjs8eEcf1UKdQCXNNU/Captura_de_pantalla_2026-04-20_a_las_11.07.31_p._m..png',
  alt: 'Sequenza Lumber-Safe: Shoulder Bridge Sequenziale'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hmp37W9cVkLhtuPVo9mSN1/Captura_de_pantalla_2026-04-20_a_las_11.07.52_p._m..png',
  alt: 'Potenziamento Adduttori e Pavimento Pelvico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rPM37DSky8r8ajnLpLV3CB/Captura_de_pantalla_2026-04-20_a_las_11.10.14_p._m..png',
  alt: 'Adattamenti Chair Pilates per Patologie Specifiche'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wyCdqhdBRwSGr34p7xm4to/Captura_de_pantalla_2026-04-20_a_las_11.10.40_p._m..png',
  alt: 'Capitolo 4 - Recupero Post-Parto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cGkmowj6yZfsj93UNuSRKY/Captura_de_pantalla_2026-04-20_a_las_11.15.15_p._m..png',
  alt: 'BPM per Ogni Fase della Lezione'
}];
export function ContentPreview() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const center = container.scrollLeft + container.clientWidth / 2;
    let minDistance = Infinity;
    let active = 0;
    Array.from(container.children).forEach((child, index) => {
      const childCenter = (child as HTMLElement).offsetLeft + (child as HTMLElement).clientWidth / 2;
      const distance = Math.abs(center - childCenter);
      if (distance < minDistance) {
        minDistance = distance;
        active = index;
      }
    });
    setActiveIndex(active);
  };
  const scrollToIndex = (index: number) => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const child = container.children[index] as HTMLElement;
    if (!child) return;
    const scrollLeft = child.offsetLeft - container.clientWidth / 2 + child.clientWidth / 2;
    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  };
  const scrollPrev = () => {
    if (activeIndex > 0) scrollToIndex(activeIndex - 1);
  };
  const scrollNext = () => {
    if (activeIndex < carouselImages.length - 1) scrollToIndex(activeIndex + 1);
  };
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-26">
            Cosa include il Kit Tecnico Pro?
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-27">
            Strumenti digitali in PDF pronti all'uso da oggi stesso.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-28">
          {items.map((item, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light overflow-hidden flex flex-col relative group hover:-translate-y-1 transition-transform duration-300" data-id="element-29">
              <div className={`${item.color} h-1.5 w-full ${item.shadow}`} data-id="element-30" />
              <div className="flex-1 flex flex-col p-8 relative" data-id="element-31">
                {/* Subtle background glow */}
                <div className={`absolute inset-0 ${item.color} opacity-[0.03] group-hover:opacity-[0.08] transition-opacity`} data-id="element-32"></div>

                <span className="text-5xl mb-5 block drop-shadow-2xl relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-33">
                  {item.emoji}
                </span>
                <h3 className="text-xl sm:text-2xl font-bold text-text-main leading-snug relative z-10 mb-3" data-id="element-34">
                  {item.title}
                </h3>
                <p className="text-text-sec text-base leading-relaxed relative z-10" data-id="element-35">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Carousel Section */}
        <div className="mt-24 relative" data-id="element-36">
          <div className="text-center mb-10" data-id="element-37">
            <h3 className="text-2xl sm:text-3xl font-bold text-text-main inline-flex items-center gap-3" data-id="element-38">
              <span data-id="element-39">📸</span> Guarda il materiale all'interno
            </h3>
            <p className="text-text-sec text-sm mt-3 flex items-center justify-center gap-2" data-id="element-40">
              <span className="inline-flex items-center gap-1.5 sm:hidden" data-id="element-41">
                <ChevronLeft className="w-4 h-4 animate-pulse" data-id="element-42" />
                Scorri per vedere di più
                <ChevronRight className="w-4 h-4 animate-pulse" data-id="element-43" />
              </span>
              <span className="text-text-sec/60 text-xs font-medium" data-id="element-44">
                {activeIndex + 1} / {carouselImages.length}
              </span>
            </p>
          </div>

          <div className="relative group max-w-[100vw] -mx-4 sm:mx-0" data-id="element-45">
            {/* Navigation buttons */}
            <button onClick={scrollPrev} className={`hidden sm:flex absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-bg-dark/80 hover:bg-bg-alt border border-border-light p-3 rounded-full text-text-main backdrop-blur-sm transition-all shadow-lg ${activeIndex === 0 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} aria-label="Precedente" data-id="element-46">
              <ChevronLeft className="w-6 h-6" data-id="element-47" />
            </button>
            <button onClick={scrollNext} className={`hidden sm:flex absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-bg-dark/80 hover:bg-bg-alt border border-border-light p-3 rounded-full text-text-main backdrop-blur-sm transition-all shadow-lg ${activeIndex === carouselImages.length - 1 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} aria-label="Successivo" data-id="element-48">
              <ChevronRight className="w-6 h-6" data-id="element-49" />
            </button>

            {/* Carousel */}
            <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-4 sm:gap-6 px-[10vw] sm:px-[calc(50%-175px)] pb-8 pt-4" data-id="element-50">
              {carouselImages.map((img, i) => <div key={i} className={`snap-center shrink-0 w-[80vw] sm:w-[350px] bg-bg-alt border border-border-light rounded-2xl overflow-hidden p-2 sm:p-3 flex items-center justify-center shadow-[0_10px_30px_rgba(0,0,0,0.3)] transition-transform duration-300 ${activeIndex === i ? 'scale-100 opacity-100' : 'scale-95 opacity-50'}`} data-id="element-51">
                  <img src={img.src} alt={img.alt} loading="lazy" decoding="async" width={800} height={1131} className="w-full h-auto max-h-[400px] sm:max-h-[450px] object-contain rounded-xl bg-white/5" data-id="element-52" />
                </div>)}
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2.5 mt-2" data-id="element-53">
            {carouselImages.map((_, i) => <button key={i} onClick={() => scrollToIndex(i)} className={`h-2 rounded-full transition-all duration-300 ${i === activeIndex ? 'bg-primary w-8' : 'bg-border-light hover:bg-text-sec w-2'}`} aria-label={`Vai all'immagine ${i + 1}`} data-id="element-54" />)}
          </div>
        </div>
      </div>
    </section>;
}